import React from "react";
import { View } from "react-native";
import { Error } from "../../types/error-types";
import { Text } from "../Text";
import { validationErrorStyles as styles } from "./styles";

interface ValidationErrorProps {
  error: Error | null;
}

const ValidationError: React.FC<ValidationErrorProps> = ({ error }) => (
  <View style={styles.errorContainer}>
    {error && (
      <Text
        style={styles.errorLabel}
      >{`${error.message} - ${error.errors?.[0] || ""}`}</Text>
    )}
  </View>
);

export default ValidationError;
